module.exports = __webpack_public_path__ + "static/media/canTakeImportant.63628158.mp3";